import { useState, useEffect } from 'react';
import {
  Typography,
  Alert,
  Button,
  Stack,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { api } from '../../api/api';
import toast from 'react-hot-toast';

// 현장 키트 서버 상태·점검 (admin) — Settings > Field Kit 탭에서 이동 (결정 ⑤ · 12.01-D008)
export default function FieldKitAdminTools() {
  const [cfg, setCfg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [testing, setTesting] = useState(false);

  useEffect(() => {
    api
      .get('/field-kit/admin-config')
      .then((res) => setCfg(res.data))
      .catch(() => setCfg({ apiKeyConfigured: false }))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return null;

  return (
    <Accordion disableGutters sx={{ mb: 2, borderRadius: 2, '&:before': { display: 'none' } }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography sx={{ fontSize: 15, fontWeight: 700 }}>현장 키트 서버 상태 · 점검</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Alert severity={cfg?.apiKeyConfigured ? 'success' : 'warning'} sx={{ mb: 2 }}>
          {cfg?.apiKeyConfigured
            ? '서버 FIELD_KIT_API_KEY 설정됨 — Digntec 직원·사내 도구 전용. 매장에는 주지 말고 위 현장 코드를 발급하세요.'
            : '서버 FIELD_KIT_API_KEY 미설정 — 직원용 키가 없습니다. 매장은 현장 코드로만 동작합니다 (.env.prod 에 16자 이상 설정 후 앱 재시작).'}
        </Alert>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          매장 원클릭 인증은 1회용 현장 코드(1시간)만 사용합니다. 공개 API(field-report · wg-provision)는 코드 세션이나 직원 키가 없으면 401 입니다.
          자세한 절차: docs/FIELD_KIT_FIELD_CODE.md
        </Typography>
        <Stack direction="row" spacing={1} flexWrap="wrap">
          <Button
            variant="outlined"
            disabled={testing}
            onClick={async () => {
              setTesting(true);
              try {
                const res = await api.post('/field-kit/smoke-test');
                toast.success(`Test OK — code ${res.data.deviceCode}`);
                window.location.reload();
              } catch (e) {
                toast.error(e.response?.data?.message || 'Smoke test failed');
              }
              setTesting(false);
            }}
          >
            {testing ? 'Testing…' : 'CMS 점검 실행 (smoke test)'}
          </Button>
          <Button href="/field-kit/" target="_blank" rel="noopener" endIcon={<OpenInNewIcon />}>
            매장용 다운로드 페이지
          </Button>
        </Stack>
      </AccordionDetails>
    </Accordion>
  );
}
